/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type IconSmall16ArrowRightIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function IconSmall16ArrowRightIcon(
  props: IconSmall16ArrowRightIconProps
) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 16 16"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M5 15a1 1 0 01-.707-1.707L9.586 8 4.293 2.707a1 1 0 011.414-1.414l6 6a1 1 0 010 1.414l-6 6A1 1 0 015 15z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  );
}

export default IconSmall16ArrowRightIcon;
/* prettier-ignore-end */
